import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useRouteError, useNavigate } from 'react-router-dom';
import { errorAnalytics } from '../helper/helper';

const ErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  useEffect(() => {
    errorAnalytics(error.message || 'An unexpected error occurred', error);
  }, [error]);
  return (
    <Box
      sx={{
        display: 'flex',  
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 3,
        backgroundColor: '#f8f9fa'
      }}
    >
      <Typography variant="h4" color="error" gutterBottom>
        Oops! Something went wrong
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        {'An unexpected error occurred'}
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(-1)}
        >
          Go Back
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => navigate('/')}
        >
          Go Home
        </Button>
      </Box>
    </Box>
  );
};

export default ErrorPage; 